import { render, staticRenderFns } from "./AllotmentShop.vue?vue&type=template&id=a296c1dc&scoped=true"
import script from "./AllotmentShop.vue?vue&type=script&lang=ts"
export * from "./AllotmentShop.vue?vue&type=script&lang=ts"
import style0 from "./AllotmentShop.vue?vue&type=style&index=0&id=a296c1dc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a296c1dc",
  null
  
)

export default component.exports